import { ROUTES } from "../../../api/api.routes"
import useCustomQuery from "../../../hooks/useQuery"
import { Session } from "../../../types/db/schema/sessions/session.schema";

export const useSession = () => {
  const {
    data,
    isLoading,
    mutate,
    isFetching
  } = useCustomQuery<Session>(ROUTES.Auth.Session);

  return {
    // session: data ? { ...data, isAdmin: false } : undefined,
    session: data,
    isLoading,
    isFetching,
    mutate
  }
}